import { useState } from "react";
import hero1 from "../Assests/Program/SDS_0635.JPG";
import hero2 from "../Assests/Program/IMG-20250917-WA0022.jpg";
import hero3 from "../Assests/Program/SDS_0689.JPG";
import hero4 from "../Assests/Program/IMG_20251114_162939.jpg";
import hero5 from "../Assests/Program/PXL_20250627_053707382.jpg";



import image1 from "../Assests/ProgramImages/img1.jpg";
import image2 from "../Assests/ProgramImages/img2.jpg";
import image3 from "../Assests/ProgramImages/img3.jpg";


import image4 from "../Assests/Program/IMG-20250917-WA0022.jpg";
import image5 from "../Assests/Program/IMG_20251114_095138874_HDR.jpg";
import image6 from "../Assests/Program/IMG-20251114-WA0110.jpg";
import image7 from "../Assests/Program/IMG-20251114-WA0111.jpg";
import image8 from "../Assests/Program/20251114_110758.jpg";
import image9 from "../Assests/Program/IMG-20250917-WA0007.jpg";
import image10 from "../Assests/Program/IMG_20250917_104001.jpg";
import image11 from "../Assests/Program/PXL_20250912_052630038.MP.jpg";
import image12 from "../Assests/Program/ima12.jpg";

const programs = [
  {
    id: "toddler-program",
    label: "Toddler Program",
    heroImage: hero1,
    age: "Age 1.5+",
    description:
      "Fine motor skills, social interaction, and musical concepts are introduced through guided play in a calm, nurturing environment.",
    highlights: [
      "Guided play for confidence and comfort",
      "Fine motor and sensory exploration",
      "Early social interaction with gentle routines",
      "Music, rhythm, and joyful classroom engagement",
    ],
    images: [
      { label: "Guided Play", url: image1 },
      { label: "Learning Corner", url: image2 },
      { label: "Happy Moments", url: image12 },
    ],
    faqs: [
      { q: "Who is Toddler Program for?", a: "It is designed for children aged 1.5 years and above." },
    ],
  },
  {
    id: "play-group",
    label: "Play Group",
    heroImage: hero2,
    age: "Age 2+",
    description:
      "Play Group encourages self-directed exploration, social communication, and musical intelligence through playful discovery.",
    highlights: [
      "Self-directed exploration and discovery",
      "Circle time and social communication practice",
      "Music-based activities and movement",
      "A warm, engaging daily routine",
    ],
    images: [
      { label: "Play Time", url: image3 },
      { label: "Friendship", url: image4 },
      { label: "Classroom Joy", url: image5 },
    ],
    faqs: [
      { q: "What age group is Play Group for?", a: "Play Group is for children aged 2 years and above." },
    ],
  },
  {
    id: "nursery",
    label: "Nursery",
    heroImage: hero3,
    age: "Age 3+",
    description:
      "Nursery builds creative expression, shapes and color recognition, and bodily-kinesthetic intelligence in a playful learning environment.",
    highlights: [
      "Creative art and expression",
      "Shapes, colors, and concept readiness",
      "Movement-rich learning experiences",
      "Confidence in peer participation",
    ],
    images: [
      { label: "Art Time", url: image6 },
      { label: "Creative Corner", url: image7 },
      { label: "Outdoor Discovery", url: image8 },
    ],
    faqs: [
      { q: "What does Nursery focus on?", a: "Nursery focuses on creativity, foundational concepts, and active learning." },
    ],
  },
  {
    id: "jr-kg",
    label: "Jr KG",
    heroImage: hero4,
    age: "Age 4+",
    description:
      "Jr KG introduces phonics, letter recognition, critical thinking, and spatial intelligence through structured, age-appropriate activities.",
    highlights: [
      "Phonics and letter recognition",
      "Readiness for writing and early literacy",
      "Critical thinking through guided tasks",
      "Visual and spatial concept development",
    ],
    images: [
      { label: "Phonics Fun", url: image9 },
      { label: "Story Circle", url: image10 },
      { label: "Skill Building", url: image11 },
    ],
    faqs: [
      { q: "How does Jr KG help children?", a: "It strengthens school-readiness with early literacy, thinking skills, and structured learning habits." },
    ],
  },
  {
    id: "sr-kg",
    label: "Sr KG",
    heroImage: hero5,
    age: "Age 5+",
    description:
      "Sr KG supports research skills, group discussions, and creative presentations to prepare children for their next learning stage.",
    highlights: [
      "Research and observation skills",
      "Group discussions and collaboration",
      "Creative presentations and speaking practice",
      "Stronger independence and responsibility",
    ],
    images: [
      { label: "Teamwork", url: image12 },
      { label: "Presentation Time", url: image8 },
      { label: "Curious Minds", url: image5 },
    ],
    faqs: [
      { q: "What is the goal of Sr KG?", a: "Sr KG builds independence, communication, and confidence before the next academic level." },
    ],
  },
  {
    id: "day-care",
    label: "Day Care",
    heroImage: hero2,
    age: "Age 1+",
    description:
      "Day Care offers a gadget-free, social, and engaging atmosphere with fun indoor and outdoor play for children aged 1 year and above.",
    highlights: [
      "Safe, caring, gadget-free environment",
      "Indoor and outdoor supervised play",
      "Social interaction throughout the day",
      "Fun routines that keep children engaged",
    ],
    images: [
      { label: "Care Time", url: image1 },
      { label: "Indoor Play", url: image4 },
      { label: "Outdoor Fun", url: image10 },
    ],
    faqs: [
      { q: "What makes Day Care special?", a: "It gives children a social, caring, and engaging environment with active play and close supervision." },
    ],
  },
];

function Accordion({ items }) {
  const [open, setOpen] = useState(null);

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div key={index} className="overflow-hidden rounded-xl border border-gray-200">
          <button
            className="flex w-full items-center justify-between px-5 py-4 text-left font-semibold text-gray-800 transition-colors hover:bg-gray-50"
            onClick={() => setOpen(open === index ? null : index)}
          >
            <span>{item.q}</span>
            <span className="ml-4 text-xl text-teal-600">{open === index ? "-" : "+"}</span>
          </button>
          {open === index && <div className="px-5 pb-4 text-sm leading-relaxed text-gray-600">{item.a}</div>}
        </div>
      ))}
    </div>
  );
}

export default function ProgramsPage() {
  const [active, setActive] = useState("toddler-program");
  const program = programs.find((item) => item.id === active) || programs[0];

  return (
    <div className="min-h-screen bg-white font-sans">
      <div className="bg-[rgb(122,49,125)] px-6 py-14 text-center text-white">
        <p className="mb-2 text-sm uppercase tracking-widest text-teal-300">Our Programs</p>
        <h1 className="text-3xl font-extrabold md:text-5xl">Explore Our Programs</h1>
        <p className="mx-auto mt-3 max-w-xl text-sm text-teal-200 md:text-base">
          Six thoughtfully designed early learning experiences for every stage from Day Care to Sr KG.
        </p>
      </div>

      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-4 py-10 lg:flex-row">
        <aside className="w-full flex-shrink-0 space-y-4 lg:w-72">
          <div className="overflow-hidden rounded-2xl border border-gray-100 shadow-sm">
            <div className="bg-[rgb(122,49,125)] px-5 py-4 text-base font-bold text-white">Explore Our Programs</div>
            <div className="divide-y divide-gray-100 bg-white">
              {programs.map((item) => (
                <button
                  key={item.id}
                  onClick={() => setActive(item.id)}
                  className={`flex w-full items-center justify-between px-5 py-4 text-left text-sm font-medium transition-colors ${
                    active === item.id ? "bg-teal-50 text-teal-700" : "text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  <span>{item.label}</span>
                  <span className="text-gray-400">→</span>
                </button>
              ))}
            </div>
          </div>
        </aside>

        <main className="min-w-0 flex-1">
          <div
            className="relative mb-6 flex h-64 w-full items-end overflow-hidden rounded-2xl p-6 md:h-80"
            style={{
              backgroundImage: `url(${program.heroImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-teal-800/70 to-teal-900/80" />
            <div className="relative z-10 text-white">
              <span className="rounded-full bg-white/20 px-3 py-1 text-xs">{program.age}</span>
              <h2 className="mt-2 text-2xl font-extrabold md:text-3xl">{program.label}</h2>
            </div>
          </div>

          <p className="mb-8 leading-relaxed text-gray-600">{program.description}</p>

          <h3 className="mb-4 text-2xl font-extrabold text-gray-900">{program.label} highlights</h3>
          <div className="mb-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {program.highlights.map((highlight, index) => (
              <div key={index} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-teal-600 text-xs text-white">✓</span>
                <span className="text-sm text-gray-700">{highlight}</span>
              </div>
            ))}
          </div>

          <div className="mb-10 grid grid-cols-1 gap-4 md:grid-cols-3">
            {program.images.map((image, index) => (
              <div key={index} className="group relative h-40 overflow-hidden rounded-2xl md:h-52">
                <img src={image.url} alt={image.label} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <span className="absolute bottom-3 left-3 z-10 text-sm font-semibold text-white">{image.label}</span>
              </div>
            ))}
          </div>

          <h3 className="mb-5 text-2xl font-extrabold text-gray-900">Frequently asked questions</h3>
          <Accordion items={program.faqs} />
        </main>
      </div>
    </div>
  );
}
